// This file is part of re-motion
// Copyright (c) rubicon IT GmbH, www.rubicon.eu
// 
import { JsonRpcError } from "@lib/messaging/rpc/jsonRpc/JsonRpcError";
import { JsonRpcRequest } from "@lib/messaging/rpc/jsonRpc/JsonRpcRequest";
import { JsonRpcResponse } from "@lib/messaging/rpc/jsonRpc/JsonRpcResponse";
import { TypeUtility } from "@lib/utilities/TypeUtility";

function isJsonRpcError(message: any): message is JsonRpcError
{
  if (typeof message !== "object")
    return false;
  if (!TypeUtility.isInteger(message.code))
    return false;
  if (!TypeUtility.isString(message.message))
    return false;
  return true;
}

export function parseJsonRpcRequest(message: Partial<JsonRpcRequest>): Nullable<JsonRpcRequest>
{
  if (!TypeUtility.isString(message.jsonrpc) || message.jsonrpc !== "2.0")
    return null;
  if ("id" in message && !TypeUtility.isString(message.id) && !TypeUtility.isInteger(message.id) && !TypeUtility.isNull(message.id))
    return null;
  if (!TypeUtility.isString(message.method))
    return null;
  if ("params" in message && !TypeUtility.isArray(message.params))
    return null;
  return message as JsonRpcRequest;
}

export function parseJsonRpcResponse(message: Partial<JsonRpcResponse>): Nullable<JsonRpcResponse>
{
  if (!TypeUtility.isObject(message))
    return null;
  if (!TypeUtility.isString(message.jsonrpc) || message.jsonrpc !== "2.0")
    return null;
  if ("id" in message && !TypeUtility.isString(message.id) && !TypeUtility.isInteger(message.id) && !TypeUtility.isNull(message.id))
    return null;
  if ("error" in message)
  {
    if (!isJsonRpcError(message.error))
      return null;
    return message as JsonRpcResponse;
  }
  else if ("result" in message)
  {
    return message as JsonRpcResponse;
  }
  else
  {
    return null;
  }
}